export const locale = {
    lang: 'pl',
    data: {
        "Orders": "Zamówienia",
        "New": "Nowe",
        "Add order": "Dodaj zamówienie",
        "Orders history": "Historia zamówień",
        "Add position": "Dodaj pozycję",
        "Product": "Produkt",
        "Unit": "Jednostka",
        "Quantity": "Ilość",
        "Price net": "Cena netto",
        "Price gross": "Cena brutto",
        "Remove": "Usuń",
        "Sale voucher": "Sprzedaj karnet",
        "Voucher sale": "Sprzedaż karnetów",
        "Products sale": "Sprzedaż produktów",
        "Worker": "Pracownik",
        "Description": "Opis",
        "Customer": "Klient",
        "Save": "Zapisz",
        "Vat rate": "VAT",
        "Voucher": "Karnet",
        "Dedication": "Dedykacja",
        "Owner": "Właściciel",
        "Price": "Wartość",
        "Created at": "Data dodania",
        "Actions": "Akcje",
        "Details": "Szczegóły",
        "Name": "Nazwa",
        "Document date": "Data dokumentu",
        "Positions": "Pozycje",
        "Payment method": "Metoda płatności",
        "Create invoice": "Utwórz fakturę",
        "Street": "Ulica",
        "Country": "Kraj",
        "Post code": "Kod pocztowy",
        "City": "Miasto",
        "Line value": "Wartość linii",
        "Order Details": "Szczegóły zamówienia",
        "Products": "Produkty",
        "Invoice": "Faktura",
        "PRODUCT": "PRODUKT",
        "INVOICE": "FAKTURA",
        "PRICE": "CENA",
        "QUANTITY": "ILOŚĆ",
        "TOTAL": "WARTOŚĆ",
        "Phone": "Telefon",
        "Company": "Firma",
        "Printed at": "Data wydrukowania",
        "Read by printer": "Odczytana przez drukarkę",
        "Printed": "Wydrukowana",
        "Yes": "Tak",
        "No": "Nie",
        "Order": "Zamówienie",
        "Add action": "Dodaj akcję",
        "Action key": "Klucz akcji",
        "Is active": "Czy aktywna",
        "Created by": "Dodał",
        "Edit": "Edycja",
        "Service": "Usługa",
        "Add item": "Dodaj usługę",
        "Action data": "Dane akcji",
        "Validity time": "Czas ważności"
    }
};
